/**
 * StatsCard Component
 * 통계 카드 - 완료/거절 건수, 수락률 표시
 */
import React from 'react';
import styles from '../../styles/shared/StatsCard.module.css';

interface StatsCardProps {
    completedCount: number;
    rejectedCount: number;
    acceptanceRate: number;
    foodCount?: number;
    bmartCount?: number;
    storeCount?: number;
}

export const StatsCard: React.FC<StatsCardProps> = ({
                                                        completedCount,
                                                        rejectedCount,
                                                        acceptanceRate,
                                                        foodCount,
                                                        bmartCount,
                                                        storeCount,
                                                    }) => {
    const hasOrderTypes = foodCount !== undefined || bmartCount !== undefined || storeCount !== undefined;

    return (
        <div className={styles['stats-card']}>
            <h2 className={styles['stats-title']}>
                <span className={styles['stats-title-icon']}>📋</span>
                배달 현황
            </h2>
            <div className={styles['stats-grid']}>
                <div className={`${styles['stat-item']} ${styles['stat-item--completed']}`}>
                    <div className={styles['stat-label']}>완료</div>
                    <div className={styles['stat-value']}>
                        {completedCount}<span className={styles['stat-unit']}>건</span>
                    </div>
                </div>
                <div className={`${styles['stat-item']} ${styles['stat-item--rejected']}`}>
                    <div className={styles['stat-label']}>거절</div>
                    <div className={styles['stat-value']}>
                        {rejectedCount}<span className={styles['stat-unit']}>건</span>
                    </div>
                </div>
                <div className={`${styles['stat-item']} ${styles['stat-item--rate']}`}>
                    <div className={styles['stat-label']}>수락률</div>
                    <div className={styles['stat-value']}>
                        {acceptanceRate}<span className={styles['stat-unit']}>%</span>
                    </div>
                </div>
            </div>
            {hasOrderTypes && (
                <>
                    <div className={styles['order-type-divider']} />
                    <div className={styles['order-type-grid']}>
                        <div className={`${styles['order-type-item']} ${styles['order-type-item--food']}`}>
                            <div className={styles['order-type-label']}>푸드</div>
                            <div className={styles['order-type-value']}>
                                {foodCount ?? 0}<span className={styles['order-type-unit']}>건</span>
                            </div>
                        </div>
                        <div className={`${styles['order-type-item']} ${styles['order-type-item--bmart']}`}>
                            <div className={styles['order-type-label']}>비마트</div>
                            <div className={styles['order-type-value']}>
                                {bmartCount ?? 0}<span className={styles['order-type-unit']}>건</span>
                            </div>
                        </div>
                        <div className={`${styles['order-type-item']} ${styles['order-type-item--store']}`}>
                            <div className={styles['order-type-label']}>스토어</div>
                            <div className={styles['order-type-value']}>
                                {storeCount ?? 0}<span className={styles['order-type-unit']}>건</span>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};
